import "react";
import "./auth-service-tools177.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { resolveClassNames } from "./auth-service-tools192.js";
import { resolveStyles } from "./auth-service-tools194.js";

function useResolvedStylesApi(_ref) {
  let {
    classNames,
    styles,
    props,
    stylesCtx
  } = _ref;
  const theme = useMantineTheme();
  return {
    resolvedClassNames: resolveClassNames({
      theme,
      classNames,
      props,
      stylesCtx: stylesCtx || void 0
    }),
    resolvedStyles: resolveStyles({
      theme,
      styles,
      props,
      stylesCtx: stylesCtx || void 0
    })
  };
}

export { useResolvedStylesApi };